import { DataGrid } from '@mui/x-data-grid'
import { useEffect, useState } from 'react'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'

function ListOperations({ fetchOperations, operations, setSelectedRows }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modifiedColumns, setModifiedColumns] = useState([])

  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'NomIngredient',
          headerName: 'Nom',

          flex: 1,

          renderCell: (params) => params.row.NomIngredient,
        },
        {
          headerName: 'Quantité',

          flex: 1,

          renderCell: (params) => {
            return (
              <>
                {params.row.Quantite} {params.row.um?.Designation}
              </>
            )
          },
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])
  const columns = [
    {
      field: 'NomIngredient',
      headerName: 'Nom',
      width: 220,
      flex: 1,
      editable: true,
      renderCell: (params) => params.row.NomIngredient,
    },
    {
      field: 'Quantite',
      headerName: 'Quantité',
      width: 80,
      flex: 1,
      editable: true,
      renderCell: (params) => params.row.Quantite,
    },
    {
      field: 'um',
      headerName: 'Unité',
      flex: 1,
      width: 80,
      editable: true,
      valueGetter: (params) => `${params.row.um?.Designation}`,
    },
  ]
  return (
    <div
      style={{
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h5"
        sx={{ color: 'black !important', textAlign: 'left', fontWeight: 600, padding: '10px' }}
      >
        Ingrédients ({operations.count})
      </Typography>

      <DataGrid
        sx={{ height: 750 }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
      />
    </div>
  )
}
export default ListOperations
